/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

import * as APITypes from "../API";
type GeneratedQuery<InputType, OutputType> = string & {
  __generatedQueryInput: InputType;
  __generatedQueryOutput: OutputType;
};

export const getAccount = /* GraphQL */ `query GetAccount($id: ID!) {
  getAccount(id: $id) {
    id
    logo
    domain
    siteTitle
    guestsCount
    tagline
    description
    siteAddress
    defaultLanguage
    languages
    features
    status
    socialLinks
    hasZATCAClearance
    deleted
    createdAt
    createdByID
    createdByName
    callCenterEmployeesIds
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetAccountQueryVariables,
  APITypes.GetAccountQuery
>;
export const listAccounts = /* GraphQL */ `query ListAccounts(
  $filter: ModelAccountFilterInput
  $limit: Int
  $nextToken: String
) {
  listAccounts(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      logo
      domain
      siteTitle
      guestsCount
      tagline
      description
      siteAddress
      defaultLanguage
      languages
      features
      status
      socialLinks
      hasZATCAClearance
      deleted
      createdAt
      createdByID
      createdByName
      callCenterEmployeesIds
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListAccountsQueryVariables,
  APITypes.ListAccountsQuery
>;
export const syncAccounts = /* GraphQL */ `query SyncAccounts(
  $filter: ModelAccountFilterInput
  $limit: Int
  $nextToken: String
  $lastSync: AWSTimestamp
) {
  syncAccounts(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    lastSync: $lastSync
  ) {
    items {
      id
      logo
      domain
      siteTitle
      guestsCount
      tagline
      description
      siteAddress
      defaultLanguage
      languages
      features
      status
      socialLinks
      hasZATCAClearance
      deleted
      createdAt
      createdByID
      createdByName
      callCenterEmployeesIds
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SyncAccountsQueryVariables,
  APITypes.SyncAccountsQuery
>;
export const getConcept = /* GraphQL */ `query GetConcept($id: ID!) {
  getConcept(id: $id) {
    id
    accountID
    name
    hotelCode
    env
    prefix
    type
    rin
    crn
    productionCertificate
    productionApiSecret
    companyTradeName
    branchCode
    activityCode
    deviceSerialNumber
    branchAddress {
      branchId
      country
      governate
      regionCity
      citySubdivision
      plotIdentification
      street
      buildingNumber
      postalCode
      floor
      room
      landmark
      additionalInformation
      __typename
    }
    clientId
    clientSecret
    ohip_client_id
    ohip_client_secret
    posSerial
    posVersion
    synchronizeProcess
    deleted
    createdAt
    createdByID
    createdByName
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetConceptQueryVariables,
  APITypes.GetConceptQuery
>;
export const listConcepts = /* GraphQL */ `query ListConcepts(
  $filter: ModelConceptFilterInput
  $limit: Int
  $nextToken: String
) {
  listConcepts(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      accountID
      name
      hotelCode
      env
      prefix
      type
      rin
      crn
      productionCertificate
      productionApiSecret
      companyTradeName
      branchCode
      activityCode
      deviceSerialNumber
      branchAddress {
        branchId
        country
        governate
        regionCity
        citySubdivision
        plotIdentification
        street
        buildingNumber
        postalCode
        floor
        room
        landmark
        additionalInformation
        __typename
      }
      clientId
      clientSecret
      ohip_client_id
      ohip_client_secret
      posSerial
      posVersion
      synchronizeProcess
      deleted
      createdAt
      createdByID
      createdByName
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListConceptsQueryVariables,
  APITypes.ListConceptsQuery
>;
export const syncConcepts = /* GraphQL */ `query SyncConcepts(
  $filter: ModelConceptFilterInput
  $limit: Int
  $nextToken: String
  $lastSync: AWSTimestamp
) {
  syncConcepts(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    lastSync: $lastSync
  ) {
    items {
      id
      accountID
      name
      hotelCode
      env
      prefix
      type
      rin
      crn
      productionCertificate
      productionApiSecret
      companyTradeName
      branchCode
      activityCode
      deviceSerialNumber
      branchAddress {
        branchId
        country
        governate
        regionCity
        citySubdivision
        plotIdentification
        street
        buildingNumber
        postalCode
        floor
        room
        landmark
        additionalInformation
        __typename
      }
      clientId
      clientSecret
      ohip_client_id
      ohip_client_secret
      posSerial
      posVersion
      synchronizeProcess
      deleted
      createdAt
      createdByID
      createdByName
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SyncConceptsQueryVariables,
  APITypes.SyncConceptsQuery
>;
export const getCustomer = /* GraphQL */ `query GetCustomer($id: ID!) {
  getCustomer(id: $id) {
    id
    accountID
    ArNumber
    vatNumber
    type
    name
    registrationNumber
    address {
      branchId
      country
      governate
      regionCity
      citySubdivision
      plotIdentification
      street
      buildingNumber
      postalCode
      floor
      room
      landmark
      additionalInformation
      __typename
    }
    mobileNumber
    paymentNumber
    deleted
    createdAt
    createdByID
    createdByName
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetCustomerQueryVariables,
  APITypes.GetCustomerQuery
>;
export const listCustomers = /* GraphQL */ `query ListCustomers(
  $filter: ModelCustomerFilterInput
  $limit: Int
  $nextToken: String
) {
  listCustomers(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      accountID
      ArNumber
      vatNumber
      type
      name
      registrationNumber
      address {
        branchId
        country
        governate
        regionCity
        citySubdivision
        plotIdentification
        street
        buildingNumber
        postalCode
        floor
        room
        landmark
        additionalInformation
        __typename
      }
      mobileNumber
      paymentNumber
      deleted
      createdAt
      createdByID
      createdByName
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListCustomersQueryVariables,
  APITypes.ListCustomersQuery
>;
export const syncCustomers = /* GraphQL */ `query SyncCustomers(
  $filter: ModelCustomerFilterInput
  $limit: Int
  $nextToken: String
  $lastSync: AWSTimestamp
) {
  syncCustomers(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    lastSync: $lastSync
  ) {
    items {
      id
      accountID
      ArNumber
      vatNumber
      type
      name
      registrationNumber
      address {
        branchId
        country
        governate
        regionCity
        citySubdivision
        plotIdentification
        street
        buildingNumber
        postalCode
        floor
        room
        landmark
        additionalInformation
        __typename
      }
      mobileNumber
      paymentNumber
      deleted
      createdAt
      createdByID
      createdByName
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SyncCustomersQueryVariables,
  APITypes.SyncCustomersQuery
>;
export const customerByArNumber = /* GraphQL */ `query CustomerByArNumber(
  $ArNumber: String!
  $sortDirection: ModelSortDirection
  $filter: ModelCustomerFilterInput
  $limit: Int
  $nextToken: String
) {
  customerByArNumber(
    ArNumber: $ArNumber
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      accountID
      ArNumber
      vatNumber
      type
      name
      registrationNumber
      address {
        branchId
        country
        governate
        regionCity
        citySubdivision
        plotIdentification
        street
        buildingNumber
        postalCode
        floor
        room
        landmark
        additionalInformation
        __typename
      }
      mobileNumber
      paymentNumber
      deleted
      createdAt
      createdByID
      createdByName
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.CustomerByArNumberQueryVariables,
  APITypes.CustomerByArNumberQuery
>;
export const customerByRegistrationNumber = /* GraphQL */ `query CustomerByRegistrationNumber(
  $registrationNumber: String!
  $sortDirection: ModelSortDirection
  $filter: ModelCustomerFilterInput
  $limit: Int
  $nextToken: String
) {
  customerByRegistrationNumber(
    registrationNumber: $registrationNumber
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      accountID
      ArNumber
      vatNumber
      type
      name
      registrationNumber
      address {
        branchId
        country
        governate
        regionCity
        citySubdivision
        plotIdentification
        street
        buildingNumber
        postalCode
        floor
        room
        landmark
        additionalInformation
        __typename
      }
      mobileNumber
      paymentNumber
      deleted
      createdAt
      createdByID
      createdByName
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.CustomerByRegistrationNumberQueryVariables,
  APITypes.CustomerByRegistrationNumberQuery
>;
export const customerByDeleted = /* GraphQL */ `query CustomerByDeleted(
  $deleted: String!
  $createdAt: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelCustomerFilterInput
  $limit: Int
  $nextToken: String
) {
  customerByDeleted(
    deleted: $deleted
    createdAt: $createdAt
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      accountID
      ArNumber
      vatNumber
      type
      name
      registrationNumber
      address {
        branchId
        country
        governate
        regionCity
        citySubdivision
        plotIdentification
        street
        buildingNumber
        postalCode
        floor
        room
        landmark
        additionalInformation
        __typename
      }
      mobileNumber
      paymentNumber
      deleted
      createdAt
      createdByID
      createdByName
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.CustomerByDeletedQueryVariables,
  APITypes.CustomerByDeletedQuery
>;
export const getFeature = /* GraphQL */ `query GetFeature($id: ID!) {
  getFeature(id: $id) {
    id
    name
    icon
    slug
    precedence
    parent
    private
    deleted
    createdAt
    createdByID
    createdByName
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetFeatureQueryVariables,
  APITypes.GetFeatureQuery
>;
export const listFeatures = /* GraphQL */ `query ListFeatures(
  $filter: ModelFeatureFilterInput
  $limit: Int
  $nextToken: String
) {
  listFeatures(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      name
      icon
      slug
      precedence
      parent
      private
      deleted
      createdAt
      createdByID
      createdByName
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListFeaturesQueryVariables,
  APITypes.ListFeaturesQuery
>;
export const syncFeatures = /* GraphQL */ `query SyncFeatures(
  $filter: ModelFeatureFilterInput
  $limit: Int
  $nextToken: String
  $lastSync: AWSTimestamp
) {
  syncFeatures(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    lastSync: $lastSync
  ) {
    items {
      id
      name
      icon
      slug
      precedence
      parent
      private
      deleted
      createdAt
      createdByID
      createdByName
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SyncFeaturesQueryVariables,
  APITypes.SyncFeaturesQuery
>;
export const getAdminRole = /* GraphQL */ `query GetAdminRole($id: ID!) {
  getAdminRole(id: $id) {
    id
    name
    description
    deleted
    createdAt
    createdByID
    createdByName
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetAdminRoleQueryVariables,
  APITypes.GetAdminRoleQuery
>;
export const listAdminRoles = /* GraphQL */ `query ListAdminRoles(
  $filter: ModelAdminRoleFilterInput
  $limit: Int
  $nextToken: String
) {
  listAdminRoles(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      name
      description
      deleted
      createdAt
      createdByID
      createdByName
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListAdminRolesQueryVariables,
  APITypes.ListAdminRolesQuery
>;
export const syncAdminRoles = /* GraphQL */ `query SyncAdminRoles(
  $filter: ModelAdminRoleFilterInput
  $limit: Int
  $nextToken: String
  $lastSync: AWSTimestamp
) {
  syncAdminRoles(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    lastSync: $lastSync
  ) {
    items {
      id
      name
      description
      deleted
      createdAt
      createdByID
      createdByName
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SyncAdminRolesQueryVariables,
  APITypes.SyncAdminRolesQuery
>;
export const getAdminGroup = /* GraphQL */ `query GetAdminGroup($id: ID!) {
  getAdminGroup(id: $id) {
    id
    name
    description
    roles
    users
    deleted
    createdAt
    createdByID
    createdByName
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetAdminGroupQueryVariables,
  APITypes.GetAdminGroupQuery
>;
export const listAdminGroups = /* GraphQL */ `query ListAdminGroups(
  $filter: ModelAdminGroupFilterInput
  $limit: Int
  $nextToken: String
) {
  listAdminGroups(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      name
      description
      roles
      users
      deleted
      createdAt
      createdByID
      createdByName
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListAdminGroupsQueryVariables,
  APITypes.ListAdminGroupsQuery
>;
export const syncAdminGroups = /* GraphQL */ `query SyncAdminGroups(
  $filter: ModelAdminGroupFilterInput
  $limit: Int
  $nextToken: String
  $lastSync: AWSTimestamp
) {
  syncAdminGroups(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    lastSync: $lastSync
  ) {
    items {
      id
      name
      description
      roles
      users
      deleted
      createdAt
      createdByID
      createdByName
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SyncAdminGroupsQueryVariables,
  APITypes.SyncAdminGroupsQuery
>;
export const getUserConcepts = /* GraphQL */ `query GetUserConcepts($id: ID!) {
  getUserConcepts(id: $id) {
    id
    defaultConcept
    concepts
    conceptsRoles
    deleted
    createdAt
    createdByID
    createdByName
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetUserConceptsQueryVariables,
  APITypes.GetUserConceptsQuery
>;
export const listUserConcepts = /* GraphQL */ `query ListUserConcepts(
  $filter: ModelUserConceptsFilterInput
  $limit: Int
  $nextToken: String
) {
  listUserConcepts(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      defaultConcept
      concepts
      conceptsRoles
      deleted
      createdAt
      createdByID
      createdByName
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListUserConceptsQueryVariables,
  APITypes.ListUserConceptsQuery
>;
export const syncUserConcepts = /* GraphQL */ `query SyncUserConcepts(
  $filter: ModelUserConceptsFilterInput
  $limit: Int
  $nextToken: String
  $lastSync: AWSTimestamp
) {
  syncUserConcepts(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    lastSync: $lastSync
  ) {
    items {
      id
      defaultConcept
      concepts
      conceptsRoles
      deleted
      createdAt
      createdByID
      createdByName
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SyncUserConceptsQueryVariables,
  APITypes.SyncUserConceptsQuery
>;
export const getLanguage = /* GraphQL */ `query GetLanguage($id: ID!) {
  getLanguage(id: $id) {
    id
    name
    code
    deleted
    createdAt
    createdByID
    createdByName
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetLanguageQueryVariables,
  APITypes.GetLanguageQuery
>;
export const listLanguages = /* GraphQL */ `query ListLanguages(
  $filter: ModelLanguageFilterInput
  $limit: Int
  $nextToken: String
) {
  listLanguages(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      name
      code
      deleted
      createdAt
      createdByID
      createdByName
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListLanguagesQueryVariables,
  APITypes.ListLanguagesQuery
>;
export const syncLanguages = /* GraphQL */ `query SyncLanguages(
  $filter: ModelLanguageFilterInput
  $limit: Int
  $nextToken: String
  $lastSync: AWSTimestamp
) {
  syncLanguages(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    lastSync: $lastSync
  ) {
    items {
      id
      name
      code
      deleted
      createdAt
      createdByID
      createdByName
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SyncLanguagesQueryVariables,
  APITypes.SyncLanguagesQuery
>;
export const getTimeline = /* GraphQL */ `query GetTimeline($id: ID!) {
  getTimeline(id: $id) {
    id
    actionName
    oldStatus
    newStatus
    userId
    transactionId
    deleted
    createdAt
    createdByID
    createdByName
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetTimelineQueryVariables,
  APITypes.GetTimelineQuery
>;
export const listTimelines = /* GraphQL */ `query ListTimelines(
  $filter: ModelTimelineFilterInput
  $limit: Int
  $nextToken: String
) {
  listTimelines(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      actionName
      oldStatus
      newStatus
      userId
      transactionId
      deleted
      createdAt
      createdByID
      createdByName
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListTimelinesQueryVariables,
  APITypes.ListTimelinesQuery
>;
export const syncTimelines = /* GraphQL */ `query SyncTimelines(
  $filter: ModelTimelineFilterInput
  $limit: Int
  $nextToken: String
  $lastSync: AWSTimestamp
) {
  syncTimelines(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    lastSync: $lastSync
  ) {
    items {
      id
      actionName
      oldStatus
      newStatus
      userId
      transactionId
      deleted
      createdAt
      createdByID
      createdByName
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SyncTimelinesQueryVariables,
  APITypes.SyncTimelinesQuery
>;
export const getItem = /* GraphQL */ `query GetItem($id: ID!) {
  getItem(id: $id) {
    id
    accountID
    internalCode
    itemCode
    description
    type
    unit
    tax1
    tax2
    neglectedItem
    deleted
    createdAt
    createdByID
    createdByName
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedQuery<APITypes.GetItemQueryVariables, APITypes.GetItemQuery>;
export const listItems = /* GraphQL */ `query ListItems(
  $filter: ModelItemFilterInput
  $limit: Int
  $nextToken: String
) {
  listItems(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      accountID
      internalCode
      itemCode
      description
      type
      unit
      tax1
      tax2
      neglectedItem
      deleted
      createdAt
      createdByID
      createdByName
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<APITypes.ListItemsQueryVariables, APITypes.ListItemsQuery>;
export const syncItems = /* GraphQL */ `query SyncItems(
  $filter: ModelItemFilterInput
  $limit: Int
  $nextToken: String
  $lastSync: AWSTimestamp
) {
  syncItems(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    lastSync: $lastSync
  ) {
    items {
      id
      accountID
      internalCode
      itemCode
      description
      type
      unit
      tax1
      tax2
      neglectedItem
      deleted
      createdAt
      createdByID
      createdByName
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<APITypes.SyncItemsQueryVariables, APITypes.SyncItemsQuery>;
export const getReceipt = /* GraphQL */ `query GetReceipt($id: ID!) {
  getReceipt(id: $id) {
    id
    conceptID
    checkNumber
    uuid
    submissionId
    header {
      dateTimeIssued
      receiptNumber
      uuid
      previousUUID
      currency
      exchangeRate
      grossWeight
      netWeight
      __typename
    }
    documentType {
      receiptType
      typeVersion
      __typename
    }
    seller {
      rin
      companyTradeName
      branchCode
      branchAddress {
        branchId
        country
        governate
        regionCity
        citySubdivision
        plotIdentification
        street
        buildingNumber
        postalCode
        floor
        room
        landmark
        additionalInformation
        __typename
      }
      deviceSerialNumber
      activityCode
      __typename
    }
    buyer {
      type
      id
      name
      mobileNumber
      paymentNumber
      __typename
    }
    itemData {
      internalCode
      description
      itemType
      itemCode
      unitType
      quantity
      unitPrice
      netSale
      totalSale
      total
      commercialDiscountData {
        amount
        description
        __typename
      }
      itemDiscountData {
        amount
        description
        __typename
      }
      valueDifference
      taxableItems {
        taxType
        amount
        subType
        rate
        __typename
      }
      __typename
    }
    totalSales
    totalCommercialDiscount
    totalItemsDiscount
    extraReceiptDiscountData {
      amount
      description
      __typename
    }
    netAmount
    feesAmount
    totalAmount
    taxTotals {
      taxType
      amount
      __typename
    }
    paymentMethod
    qrString
    qrImage
    status
    reason
    type
    returned
    deleted
    createdAt
    createdByID
    createdByName
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetReceiptQueryVariables,
  APITypes.GetReceiptQuery
>;
export const listReceipts = /* GraphQL */ `query ListReceipts(
  $filter: ModelReceiptFilterInput
  $limit: Int
  $nextToken: String
) {
  listReceipts(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      conceptID
      checkNumber
      uuid
      submissionId
      header {
        dateTimeIssued
        receiptNumber
        uuid
        previousUUID
        currency
        exchangeRate
        grossWeight
        netWeight
        __typename
      }
      documentType {
        receiptType
        typeVersion
        __typename
      }
      seller {
        rin
        companyTradeName
        branchCode
        branchAddress {
          branchId
          country
          governate
          regionCity
          citySubdivision
          plotIdentification
          street
          buildingNumber
          postalCode
          floor
          room
          landmark
          additionalInformation
          __typename
        }
        deviceSerialNumber
        activityCode
        __typename
      }
      buyer {
        type
        id
        name
        mobileNumber
        paymentNumber
        __typename
      }
      itemData {
        internalCode
        description
        itemType
        itemCode
        unitType
        quantity
        unitPrice
        netSale
        totalSale
        total
        commercialDiscountData {
          amount
          description
          __typename
        }
        itemDiscountData {
          amount
          description
          __typename
        }
        valueDifference
        taxableItems {
          taxType
          amount
          subType
          rate
          __typename
        }
        __typename
      }
      totalSales
      totalCommercialDiscount
      totalItemsDiscount
      extraReceiptDiscountData {
        amount
        description
        __typename
      }
      netAmount
      feesAmount
      totalAmount
      taxTotals {
        taxType
        amount
        __typename
      }
      paymentMethod
      qrString
      qrImage
      status
      reason
      type
      returned
      deleted
      createdAt
      createdByID
      createdByName
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListReceiptsQueryVariables,
  APITypes.ListReceiptsQuery
>;
export const syncReceipts = /* GraphQL */ `query SyncReceipts(
  $filter: ModelReceiptFilterInput
  $limit: Int
  $nextToken: String
  $lastSync: AWSTimestamp
) {
  syncReceipts(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    lastSync: $lastSync
  ) {
    items {
      id
      conceptID
      checkNumber
      uuid
      submissionId
      header {
        dateTimeIssued
        receiptNumber
        uuid
        previousUUID
        currency
        exchangeRate
        grossWeight
        netWeight
        __typename
      }
      documentType {
        receiptType
        typeVersion
        __typename
      }
      seller {
        rin
        companyTradeName
        branchCode
        branchAddress {
          branchId
          country
          governate
          regionCity
          citySubdivision
          plotIdentification
          street
          buildingNumber
          postalCode
          floor
          room
          landmark
          additionalInformation
          __typename
        }
        deviceSerialNumber
        activityCode
        __typename
      }
      buyer {
        type
        id
        name
        mobileNumber
        paymentNumber
        __typename
      }
      itemData {
        internalCode
        description
        itemType
        itemCode
        unitType
        quantity
        unitPrice
        netSale
        totalSale
        total
        commercialDiscountData {
          amount
          description
          __typename
        }
        itemDiscountData {
          amount
          description
          __typename
        }
        valueDifference
        taxableItems {
          taxType
          amount
          subType
          rate
          __typename
        }
        __typename
      }
      totalSales
      totalCommercialDiscount
      totalItemsDiscount
      extraReceiptDiscountData {
        amount
        description
        __typename
      }
      netAmount
      feesAmount
      totalAmount
      taxTotals {
        taxType
        amount
        __typename
      }
      paymentMethod
      qrString
      qrImage
      status
      reason
      type
      returned
      deleted
      createdAt
      createdByID
      createdByName
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SyncReceiptsQueryVariables,
  APITypes.SyncReceiptsQuery
>;
export const receiptByConcept = /* GraphQL */ `query ReceiptByConcept(
  $conceptID: ID!
  $checkNumber: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelReceiptFilterInput
  $limit: Int
  $nextToken: String
) {
  receiptByConcept(
    conceptID: $conceptID
    checkNumber: $checkNumber
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      conceptID
      checkNumber
      uuid
      submissionId
      header {
        dateTimeIssued
        receiptNumber
        uuid
        previousUUID
        currency
        exchangeRate
        grossWeight
        netWeight
        __typename
      }
      documentType {
        receiptType
        typeVersion
        __typename
      }
      seller {
        rin
        companyTradeName
        branchCode
        branchAddress {
          branchId
          country
          governate
          regionCity
          citySubdivision
          plotIdentification
          street
          buildingNumber
          postalCode
          floor
          room
          landmark
          additionalInformation
          __typename
        }
        deviceSerialNumber
        activityCode
        __typename
      }
      buyer {
        type
        id
        name
        mobileNumber
        paymentNumber
        __typename
      }
      itemData {
        internalCode
        description
        itemType
        itemCode
        unitType
        quantity
        unitPrice
        netSale
        totalSale
        total
        commercialDiscountData {
          amount
          description
          __typename
        }
        itemDiscountData {
          amount
          description
          __typename
        }
        valueDifference
        taxableItems {
          taxType
          amount
          subType
          rate
          __typename
        }
        __typename
      }
      totalSales
      totalCommercialDiscount
      totalItemsDiscount
      extraReceiptDiscountData {
        amount
        description
        __typename
      }
      netAmount
      feesAmount
      totalAmount
      taxTotals {
        taxType
        amount
        __typename
      }
      paymentMethod
      qrString
      qrImage
      status
      reason
      type
      returned
      deleted
      createdAt
      createdByID
      createdByName
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ReceiptByConceptQueryVariables,
  APITypes.ReceiptByConceptQuery
>;
export const getInvoice = /* GraphQL */ `query GetInvoice($id: ID!) {
  getInvoice(id: $id) {
    id
    conceptID
    issuer {
      type
      id
      name
      address {
        branchId
        country
        governate
        regionCity
        citySubdivision
        plotIdentification
        street
        buildingNumber
        postalCode
        floor
        room
        landmark
        additionalInformation
        __typename
      }
      __typename
    }
    receiver {
      type
      id
      name
      address {
        branchId
        country
        governate
        regionCity
        citySubdivision
        plotIdentification
        street
        buildingNumber
        postalCode
        floor
        room
        landmark
        additionalInformation
        __typename
      }
      __typename
    }
    documentType
    documentTypeVersion
    dateTimeIssued
    taxpayerActivityCode
    internalID
    invoiceLines {
      description
      itemType
      itemCode
      unitType
      quantity
      internalCode
      salesTotal
      total
      valueDifference
      totalTaxableFees
      netTotal
      itemsDiscount
      unitValue {
        currencySold
        amountEGP
        amountSold
        currencyExchangeRate
        __typename
      }
      taxableItems {
        taxType
        amount
        subType
        rate
        __typename
      }
      __typename
    }
    invoiceNeglectedLines {
      description
      itemType
      itemCode
      unitType
      quantity
      internalCode
      salesTotal
      total
      valueDifference
      totalTaxableFees
      netTotal
      itemsDiscount
      unitValue {
        currencySold
        amountEGP
        amountSold
        currencyExchangeRate
        __typename
      }
      taxableItems {
        taxType
        amount
        subType
        rate
        __typename
      }
      __typename
    }
    totalDiscountAmount
    totalSalesAmount
    netAmount
    taxTotals {
      taxType
      amount
      __typename
    }
    totalAmount
    extraDiscountAmount
    totalItemsDiscountAmount
    purchaseOrderReference
    uuid
    type
    cancelReason
    qrString
    qrImage
    status
    reason
    deleted
    createdAt
    createdByID
    createdByName
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetInvoiceQueryVariables,
  APITypes.GetInvoiceQuery
>;
export const listInvoices = /* GraphQL */ `query ListInvoices(
  $filter: ModelInvoiceFilterInput
  $limit: Int
  $nextToken: String
) {
  listInvoices(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      conceptID
      issuer {
        type
        id
        name
        address {
          branchId
          country
          governate
          regionCity
          citySubdivision
          plotIdentification
          street
          buildingNumber
          postalCode
          floor
          room
          landmark
          additionalInformation
          __typename
        }
        __typename
      }
      receiver {
        type
        id
        name
        address {
          branchId
          country
          governate
          regionCity
          citySubdivision
          plotIdentification
          street
          buildingNumber
          postalCode
          floor
          room
          landmark
          additionalInformation
          __typename
        }
        __typename
      }
      documentType
      documentTypeVersion
      dateTimeIssued
      taxpayerActivityCode
      internalID
      invoiceLines {
        description
        itemType
        itemCode
        unitType
        quantity
        internalCode
        salesTotal
        total
        valueDifference
        totalTaxableFees
        netTotal
        itemsDiscount
        unitValue {
          currencySold
          amountEGP
          amountSold
          currencyExchangeRate
          __typename
        }
        taxableItems {
          taxType
          amount
          subType
          rate
          __typename
        }
        __typename
      }
      invoiceNeglectedLines {
        description
        itemType
        itemCode
        unitType
        quantity
        internalCode
        salesTotal
        total
        valueDifference
        totalTaxableFees
        netTotal
        itemsDiscount
        unitValue {
          currencySold
          amountEGP
          amountSold
          currencyExchangeRate
          __typename
        }
        taxableItems {
          taxType
          amount
          subType
          rate
          __typename
        }
        __typename
      }
      totalDiscountAmount
      totalSalesAmount
      netAmount
      taxTotals {
        taxType
        amount
        __typename
      }
      totalAmount
      extraDiscountAmount
      totalItemsDiscountAmount
      purchaseOrderReference
      uuid
      type
      cancelReason
      qrString
      qrImage
      status
      reason
      deleted
      createdAt
      createdByID
      createdByName
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListInvoicesQueryVariables,
  APITypes.ListInvoicesQuery
>;
export const syncInvoices = /* GraphQL */ `query SyncInvoices(
  $filter: ModelInvoiceFilterInput
  $limit: Int
  $nextToken: String
  $lastSync: AWSTimestamp
) {
  syncInvoices(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    lastSync: $lastSync
  ) {
    items {
      id
      conceptID
      issuer {
        type
        id
        name
        address {
          branchId
          country
          governate
          regionCity
          citySubdivision
          plotIdentification
          street
          buildingNumber
          postalCode
          floor
          room
          landmark
          additionalInformation
          __typename
        }
        __typename
      }
      receiver {
        type
        id
        name
        address {
          branchId
          country
          governate
          regionCity
          citySubdivision
          plotIdentification
          street
          buildingNumber
          postalCode
          floor
          room
          landmark
          additionalInformation
          __typename
        }
        __typename
      }
      documentType
      documentTypeVersion
      dateTimeIssued
      taxpayerActivityCode
      internalID
      invoiceLines {
        description
        itemType
        itemCode
        unitType
        quantity
        internalCode
        salesTotal
        total
        valueDifference
        totalTaxableFees
        netTotal
        itemsDiscount
        unitValue {
          currencySold
          amountEGP
          amountSold
          currencyExchangeRate
          __typename
        }
        taxableItems {
          taxType
          amount
          subType
          rate
          __typename
        }
        __typename
      }
      invoiceNeglectedLines {
        description
        itemType
        itemCode
        unitType
        quantity
        internalCode
        salesTotal
        total
        valueDifference
        totalTaxableFees
        netTotal
        itemsDiscount
        unitValue {
          currencySold
          amountEGP
          amountSold
          currencyExchangeRate
          __typename
        }
        taxableItems {
          taxType
          amount
          subType
          rate
          __typename
        }
        __typename
      }
      totalDiscountAmount
      totalSalesAmount
      netAmount
      taxTotals {
        taxType
        amount
        __typename
      }
      totalAmount
      extraDiscountAmount
      totalItemsDiscountAmount
      purchaseOrderReference
      uuid
      type
      cancelReason
      qrString
      qrImage
      status
      reason
      deleted
      createdAt
      createdByID
      createdByName
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SyncInvoicesQueryVariables,
  APITypes.SyncInvoicesQuery
>;
export const invoiceByConcept = /* GraphQL */ `query InvoiceByConcept(
  $conceptID: ID!
  $internalID: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelInvoiceFilterInput
  $limit: Int
  $nextToken: String
) {
  invoiceByConcept(
    conceptID: $conceptID
    internalID: $internalID
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      conceptID
      issuer {
        type
        id
        name
        address {
          branchId
          country
          governate
          regionCity
          citySubdivision
          plotIdentification
          street
          buildingNumber
          postalCode
          floor
          room
          landmark
          additionalInformation
          __typename
        }
        __typename
      }
      receiver {
        type
        id
        name
        address {
          branchId
          country
          governate
          regionCity
          citySubdivision
          plotIdentification
          street
          buildingNumber
          postalCode
          floor
          room
          landmark
          additionalInformation
          __typename
        }
        __typename
      }
      documentType
      documentTypeVersion
      dateTimeIssued
      taxpayerActivityCode
      internalID
      invoiceLines {
        description
        itemType
        itemCode
        unitType
        quantity
        internalCode
        salesTotal
        total
        valueDifference
        totalTaxableFees
        netTotal
        itemsDiscount
        unitValue {
          currencySold
          amountEGP
          amountSold
          currencyExchangeRate
          __typename
        }
        taxableItems {
          taxType
          amount
          subType
          rate
          __typename
        }
        __typename
      }
      invoiceNeglectedLines {
        description
        itemType
        itemCode
        unitType
        quantity
        internalCode
        salesTotal
        total
        valueDifference
        totalTaxableFees
        netTotal
        itemsDiscount
        unitValue {
          currencySold
          amountEGP
          amountSold
          currencyExchangeRate
          __typename
        }
        taxableItems {
          taxType
          amount
          subType
          rate
          __typename
        }
        __typename
      }
      totalDiscountAmount
      totalSalesAmount
      netAmount
      taxTotals {
        taxType
        amount
        __typename
      }
      totalAmount
      extraDiscountAmount
      totalItemsDiscountAmount
      purchaseOrderReference
      uuid
      type
      cancelReason
      qrString
      qrImage
      status
      reason
      deleted
      createdAt
      createdByID
      createdByName
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.InvoiceByConceptQueryVariables,
  APITypes.InvoiceByConceptQuery
>;
export const invoiceByConceptDate = /* GraphQL */ `query InvoiceByConceptDate(
  $conceptID: ID!
  $createdAt: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelInvoiceFilterInput
  $limit: Int
  $nextToken: String
) {
  invoiceByConceptDate(
    conceptID: $conceptID
    createdAt: $createdAt
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      conceptID
      issuer {
        type
        id
        name
        address {
          branchId
          country
          governate
          regionCity
          citySubdivision
          plotIdentification
          street
          buildingNumber
          postalCode
          floor
          room
          landmark
          additionalInformation
          __typename
        }
        __typename
      }
      receiver {
        type
        id
        name
        address {
          branchId
          country
          governate
          regionCity
          citySubdivision
          plotIdentification
          street
          buildingNumber
          postalCode
          floor
          room
          landmark
          additionalInformation
          __typename
        }
        __typename
      }
      documentType
      documentTypeVersion
      dateTimeIssued
      taxpayerActivityCode
      internalID
      invoiceLines {
        description
        itemType
        itemCode
        unitType
        quantity
        internalCode
        salesTotal
        total
        valueDifference
        totalTaxableFees
        netTotal
        itemsDiscount
        unitValue {
          currencySold
          amountEGP
          amountSold
          currencyExchangeRate
          __typename
        }
        taxableItems {
          taxType
          amount
          subType
          rate
          __typename
        }
        __typename
      }
      invoiceNeglectedLines {
        description
        itemType
        itemCode
        unitType
        quantity
        internalCode
        salesTotal
        total
        valueDifference
        totalTaxableFees
        netTotal
        itemsDiscount
        unitValue {
          currencySold
          amountEGP
          amountSold
          currencyExchangeRate
          __typename
        }
        taxableItems {
          taxType
          amount
          subType
          rate
          __typename
        }
        __typename
      }
      totalDiscountAmount
      totalSalesAmount
      netAmount
      taxTotals {
        taxType
        amount
        __typename
      }
      totalAmount
      extraDiscountAmount
      totalItemsDiscountAmount
      purchaseOrderReference
      uuid
      type
      cancelReason
      qrString
      qrImage
      status
      reason
      deleted
      createdAt
      createdByID
      createdByName
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.InvoiceByConceptDateQueryVariables,
  APITypes.InvoiceByConceptDateQuery
>;
export const getZatcaInvoice = /* GraphQL */ `query GetZatcaInvoice($id: ID!) {
  getZatcaInvoice(id: $id) {
    id
    conceptID
    invoiceCounterNumber
    invoiceSerialNumber
    invoiceHash
    isUsed
    pcsid
    billNumber
    invoiceRefrence
    folioNumber
    customerID
    customer {
      id
      accountID
      ArNumber
      vatNumber
      type
      name
      registrationNumber
      address {
        branchId
        country
        governate
        regionCity
        citySubdivision
        plotIdentification
        street
        buildingNumber
        postalCode
        floor
        room
        landmark
        additionalInformation
        __typename
      }
      mobileNumber
      paymentNumber
      deleted
      createdAt
      createdByID
      createdByName
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    documentType
    type
    status
    dateTimeIssued
    invoiceLines {
      id
      name
      quantity
      taxExclusivePrice
      vatPercent
      discounts {
        amount
        description
        __typename
      }
      VatExemptionReason
      priceAmount
      taxAmount
      roundingAmount
      __typename
    }
    taxExclusiveAmount
    taxInclusiveAmount
    allowanceTotalAmount
    prepaidAmount
    payableAmount
    xmlDocumentEncoded
    uuid
    failureReason
    qrString
    qrImage
    infoMessages
    warningMessages
    errorMessages
    isCancelled
    clearanceStatus
    reportingStatus
    deleted
    createdAt
    createdByID
    createdByName
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetZatcaInvoiceQueryVariables,
  APITypes.GetZatcaInvoiceQuery
>;
export const listZatcaInvoices = /* GraphQL */ `query ListZatcaInvoices(
  $filter: ModelZatcaInvoiceFilterInput
  $limit: Int
  $nextToken: String
) {
  listZatcaInvoices(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      conceptID
      invoiceCounterNumber
      invoiceSerialNumber
      invoiceHash
      isUsed
      pcsid
      billNumber
      invoiceRefrence
      folioNumber
      customerID
      customer {
        id
        accountID
        ArNumber
        vatNumber
        type
        name
        registrationNumber
        address {
          branchId
          country
          governate
          regionCity
          citySubdivision
          plotIdentification
          street
          buildingNumber
          postalCode
          floor
          room
          landmark
          additionalInformation
          __typename
        }
        mobileNumber
        paymentNumber
        deleted
        createdAt
        createdByID
        createdByName
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      documentType
      type
      status
      dateTimeIssued
      invoiceLines {
        id
        name
        quantity
        taxExclusivePrice
        vatPercent
        discounts {
          amount
          description
          __typename
        }
        VatExemptionReason
        priceAmount
        taxAmount
        roundingAmount
        __typename
      }
      taxExclusiveAmount
      taxInclusiveAmount
      allowanceTotalAmount
      prepaidAmount
      payableAmount
      xmlDocumentEncoded
      uuid
      failureReason
      qrString
      qrImage
      infoMessages
      warningMessages
      errorMessages
      isCancelled
      clearanceStatus
      reportingStatus
      deleted
      createdAt
      createdByID
      createdByName
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListZatcaInvoicesQueryVariables,
  APITypes.ListZatcaInvoicesQuery
>;
export const syncZatcaInvoices = /* GraphQL */ `query SyncZatcaInvoices(
  $filter: ModelZatcaInvoiceFilterInput
  $limit: Int
  $nextToken: String
  $lastSync: AWSTimestamp
) {
  syncZatcaInvoices(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    lastSync: $lastSync
  ) {
    items {
      id
      conceptID
      invoiceCounterNumber
      invoiceSerialNumber
      invoiceHash
      isUsed
      pcsid
      billNumber
      invoiceRefrence
      folioNumber
      customerID
      customer {
        id
        accountID
        ArNumber
        vatNumber
        type
        name
        registrationNumber
        address {
          branchId
          country
          governate
          regionCity
          citySubdivision
          plotIdentification
          street
          buildingNumber
          postalCode
          floor
          room
          landmark
          additionalInformation
          __typename
        }
        mobileNumber
        paymentNumber
        deleted
        createdAt
        createdByID
        createdByName
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      documentType
      type
      status
      dateTimeIssued
      invoiceLines {
        id
        name
        quantity
        taxExclusivePrice
        vatPercent
        discounts {
          amount
          description
          __typename
        }
        VatExemptionReason
        priceAmount
        taxAmount
        roundingAmount
        __typename
      }
      taxExclusiveAmount
      taxInclusiveAmount
      allowanceTotalAmount
      prepaidAmount
      payableAmount
      xmlDocumentEncoded
      uuid
      failureReason
      qrString
      qrImage
      infoMessages
      warningMessages
      errorMessages
      isCancelled
      clearanceStatus
      reportingStatus
      deleted
      createdAt
      createdByID
      createdByName
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SyncZatcaInvoicesQueryVariables,
  APITypes.SyncZatcaInvoicesQuery
>;
export const zatcaInvoiceByConceptDate = /* GraphQL */ `query ZatcaInvoiceByConceptDate(
  $conceptID: ID!
  $createdAt: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelZatcaInvoiceFilterInput
  $limit: Int
  $nextToken: String
) {
  zatcaInvoiceByConceptDate(
    conceptID: $conceptID
    createdAt: $createdAt
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      conceptID
      invoiceCounterNumber
      invoiceSerialNumber
      invoiceHash
      isUsed
      pcsid
      billNumber
      invoiceRefrence
      folioNumber
      customerID
      customer {
        id
        accountID
        ArNumber
        vatNumber
        type
        name
        registrationNumber
        address {
          branchId
          country
          governate
          regionCity
          citySubdivision
          plotIdentification
          street
          buildingNumber
          postalCode
          floor
          room
          landmark
          additionalInformation
          __typename
        }
        mobileNumber
        paymentNumber
        deleted
        createdAt
        createdByID
        createdByName
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      documentType
      type
      status
      dateTimeIssued
      invoiceLines {
        id
        name
        quantity
        taxExclusivePrice
        vatPercent
        discounts {
          amount
          description
          __typename
        }
        VatExemptionReason
        priceAmount
        taxAmount
        roundingAmount
        __typename
      }
      taxExclusiveAmount
      taxInclusiveAmount
      allowanceTotalAmount
      prepaidAmount
      payableAmount
      xmlDocumentEncoded
      uuid
      failureReason
      qrString
      qrImage
      infoMessages
      warningMessages
      errorMessages
      isCancelled
      clearanceStatus
      reportingStatus
      deleted
      createdAt
      createdByID
      createdByName
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ZatcaInvoiceByConceptDateQueryVariables,
  APITypes.ZatcaInvoiceByConceptDateQuery
>;
export const zatcaInvoiceByConceptCounter = /* GraphQL */ `query ZatcaInvoiceByConceptCounter(
  $conceptID: ID!
  $invoiceCounterNumber: ModelIntKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelZatcaInvoiceFilterInput
  $limit: Int
  $nextToken: String
) {
  zatcaInvoiceByConceptCounter(
    conceptID: $conceptID
    invoiceCounterNumber: $invoiceCounterNumber
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      conceptID
      invoiceCounterNumber
      invoiceSerialNumber
      invoiceHash
      isUsed
      pcsid
      billNumber
      invoiceRefrence
      folioNumber
      customerID
      customer {
        id
        accountID
        ArNumber
        vatNumber
        type
        name
        registrationNumber
        address {
          branchId
          country
          governate
          regionCity
          citySubdivision
          plotIdentification
          street
          buildingNumber
          postalCode
          floor
          room
          landmark
          additionalInformation
          __typename
        }
        mobileNumber
        paymentNumber
        deleted
        createdAt
        createdByID
        createdByName
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      documentType
      type
      status
      dateTimeIssued
      invoiceLines {
        id
        name
        quantity
        taxExclusivePrice
        vatPercent
        discounts {
          amount
          description
          __typename
        }
        VatExemptionReason
        priceAmount
        taxAmount
        roundingAmount
        __typename
      }
      taxExclusiveAmount
      taxInclusiveAmount
      allowanceTotalAmount
      prepaidAmount
      payableAmount
      xmlDocumentEncoded
      uuid
      failureReason
      qrString
      qrImage
      infoMessages
      warningMessages
      errorMessages
      isCancelled
      clearanceStatus
      reportingStatus
      deleted
      createdAt
      createdByID
      createdByName
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ZatcaInvoiceByConceptCounterQueryVariables,
  APITypes.ZatcaInvoiceByConceptCounterQuery
>;
export const zatcaInvoicesByBillNumber = /* GraphQL */ `query ZatcaInvoicesByBillNumber(
  $billNumber: String!
  $sortDirection: ModelSortDirection
  $filter: ModelZatcaInvoiceFilterInput
  $limit: Int
  $nextToken: String
) {
  zatcaInvoicesByBillNumber(
    billNumber: $billNumber
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      conceptID
      invoiceCounterNumber
      invoiceSerialNumber
      invoiceHash
      isUsed
      pcsid
      billNumber
      invoiceRefrence
      folioNumber
      customerID
      customer {
        id
        accountID
        ArNumber
        vatNumber
        type
        name
        registrationNumber
        address {
          branchId
          country
          governate
          regionCity
          citySubdivision
          plotIdentification
          street
          buildingNumber
          postalCode
          floor
          room
          landmark
          additionalInformation
          __typename
        }
        mobileNumber
        paymentNumber
        deleted
        createdAt
        createdByID
        createdByName
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      documentType
      type
      status
      dateTimeIssued
      invoiceLines {
        id
        name
        quantity
        taxExclusivePrice
        vatPercent
        discounts {
          amount
          description
          __typename
        }
        VatExemptionReason
        priceAmount
        taxAmount
        roundingAmount
        __typename
      }
      taxExclusiveAmount
      taxInclusiveAmount
      allowanceTotalAmount
      prepaidAmount
      payableAmount
      xmlDocumentEncoded
      uuid
      failureReason
      qrString
      qrImage
      infoMessages
      warningMessages
      errorMessages
      isCancelled
      clearanceStatus
      reportingStatus
      deleted
      createdAt
      createdByID
      createdByName
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ZatcaInvoicesByBillNumberQueryVariables,
  APITypes.ZatcaInvoicesByBillNumberQuery
>;
export const zatcaInvoicesByFolioNumber = /* GraphQL */ `query ZatcaInvoicesByFolioNumber(
  $folioNumber: String!
  $sortDirection: ModelSortDirection
  $filter: ModelZatcaInvoiceFilterInput
  $limit: Int
  $nextToken: String
) {
  zatcaInvoicesByFolioNumber(
    folioNumber: $folioNumber
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      conceptID
      invoiceCounterNumber
      invoiceSerialNumber
      invoiceHash
      isUsed
      pcsid
      billNumber
      invoiceRefrence
      folioNumber
      customerID
      customer {
        id
        accountID
        ArNumber
        vatNumber
        type
        name
        registrationNumber
        address {
          branchId
          country
          governate
          regionCity
          citySubdivision
          plotIdentification
          street
          buildingNumber
          postalCode
          floor
          room
          landmark
          additionalInformation
          __typename
        }
        mobileNumber
        paymentNumber
        deleted
        createdAt
        createdByID
        createdByName
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      documentType
      type
      status
      dateTimeIssued
      invoiceLines {
        id
        name
        quantity
        taxExclusivePrice
        vatPercent
        discounts {
          amount
          description
          __typename
        }
        VatExemptionReason
        priceAmount
        taxAmount
        roundingAmount
        __typename
      }
      taxExclusiveAmount
      taxInclusiveAmount
      allowanceTotalAmount
      prepaidAmount
      payableAmount
      xmlDocumentEncoded
      uuid
      failureReason
      qrString
      qrImage
      infoMessages
      warningMessages
      errorMessages
      isCancelled
      clearanceStatus
      reportingStatus
      deleted
      createdAt
      createdByID
      createdByName
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ZatcaInvoicesByFolioNumberQueryVariables,
  APITypes.ZatcaInvoicesByFolioNumberQuery
>;
export const zatcaInvoicesByDeleted = /* GraphQL */ `query ZatcaInvoicesByDeleted(
  $deleted: String!
  $invoiceCounterNumber: ModelIntKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelZatcaInvoiceFilterInput
  $limit: Int
  $nextToken: String
) {
  zatcaInvoicesByDeleted(
    deleted: $deleted
    invoiceCounterNumber: $invoiceCounterNumber
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      conceptID
      invoiceCounterNumber
      invoiceSerialNumber
      invoiceHash
      isUsed
      pcsid
      billNumber
      invoiceRefrence
      folioNumber
      customerID
      customer {
        id
        accountID
        ArNumber
        vatNumber
        type
        name
        registrationNumber
        address {
          branchId
          country
          governate
          regionCity
          citySubdivision
          plotIdentification
          street
          buildingNumber
          postalCode
          floor
          room
          landmark
          additionalInformation
          __typename
        }
        mobileNumber
        paymentNumber
        deleted
        createdAt
        createdByID
        createdByName
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      documentType
      type
      status
      dateTimeIssued
      invoiceLines {
        id
        name
        quantity
        taxExclusivePrice
        vatPercent
        discounts {
          amount
          description
          __typename
        }
        VatExemptionReason
        priceAmount
        taxAmount
        roundingAmount
        __typename
      }
      taxExclusiveAmount
      taxInclusiveAmount
      allowanceTotalAmount
      prepaidAmount
      payableAmount
      xmlDocumentEncoded
      uuid
      failureReason
      qrString
      qrImage
      infoMessages
      warningMessages
      errorMessages
      isCancelled
      clearanceStatus
      reportingStatus
      deleted
      createdAt
      createdByID
      createdByName
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ZatcaInvoicesByDeletedQueryVariables,
  APITypes.ZatcaInvoicesByDeletedQuery
>;
export const getInvoker = /* GraphQL */ `query GetInvoker($id: ID!) {
  getInvoker(id: $id) {
    id
    conceptID
    userName
    password
    operations
    deleted
    createdAt
    createdByID
    createdByName
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetInvokerQueryVariables,
  APITypes.GetInvokerQuery
>;
export const listInvokers = /* GraphQL */ `query ListInvokers(
  $filter: ModelInvokerFilterInput
  $limit: Int
  $nextToken: String
) {
  listInvokers(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      conceptID
      userName
      password
      operations
      deleted
      createdAt
      createdByID
      createdByName
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListInvokersQueryVariables,
  APITypes.ListInvokersQuery
>;
export const syncInvokers = /* GraphQL */ `query SyncInvokers(
  $filter: ModelInvokerFilterInput
  $limit: Int
  $nextToken: String
  $lastSync: AWSTimestamp
) {
  syncInvokers(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    lastSync: $lastSync
  ) {
    items {
      id
      conceptID
      userName
      password
      operations
      deleted
      createdAt
      createdByID
      createdByName
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SyncInvokersQueryVariables,
  APITypes.SyncInvokersQuery
>;
export const invokersByUserName = /* GraphQL */ `query InvokersByUserName(
  $userName: String!
  $deleted: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelInvokerFilterInput
  $limit: Int
  $nextToken: String
) {
  invokersByUserName(
    userName: $userName
    deleted: $deleted
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      conceptID
      userName
      password
      operations
      deleted
      createdAt
      createdByID
      createdByName
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.InvokersByUserNameQueryVariables,
  APITypes.InvokersByUserNameQuery
>;
export const invokersByDeleted = /* GraphQL */ `query InvokersByDeleted(
  $deleted: String!
  $createdAt: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelInvokerFilterInput
  $limit: Int
  $nextToken: String
) {
  invokersByDeleted(
    deleted: $deleted
    createdAt: $createdAt
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      conceptID
      userName
      password
      operations
      deleted
      createdAt
      createdByID
      createdByName
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.InvokersByDeletedQueryVariables,
  APITypes.InvokersByDeletedQuery
>;
export const getZatcaInvoicesSequence = /* GraphQL */ `query GetZatcaInvoicesSequence($id: ID!) {
  getZatcaInvoicesSequence(id: $id) {
    id
    conceptID
    invoiceCounterNumber
    invoiceHash
    isUsed
    pcsid
    deleted
    createdAt
    createdByID
    createdByName
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetZatcaInvoicesSequenceQueryVariables,
  APITypes.GetZatcaInvoicesSequenceQuery
>;
export const listZatcaInvoicesSequences = /* GraphQL */ `query ListZatcaInvoicesSequences(
  $filter: ModelZatcaInvoicesSequenceFilterInput
  $limit: Int
  $nextToken: String
) {
  listZatcaInvoicesSequences(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      conceptID
      invoiceCounterNumber
      invoiceHash
      isUsed
      pcsid
      deleted
      createdAt
      createdByID
      createdByName
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListZatcaInvoicesSequencesQueryVariables,
  APITypes.ListZatcaInvoicesSequencesQuery
>;
export const syncZatcaInvoicesSequences = /* GraphQL */ `query SyncZatcaInvoicesSequences(
  $filter: ModelZatcaInvoicesSequenceFilterInput
  $limit: Int
  $nextToken: String
  $lastSync: AWSTimestamp
) {
  syncZatcaInvoicesSequences(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    lastSync: $lastSync
  ) {
    items {
      id
      conceptID
      invoiceCounterNumber
      invoiceHash
      isUsed
      pcsid
      deleted
      createdAt
      createdByID
      createdByName
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SyncZatcaInvoicesSequencesQueryVariables,
  APITypes.SyncZatcaInvoicesSequencesQuery
>;
export const zatcaInvoicesSequenceByConceptID = /* GraphQL */ `query ZatcaInvoicesSequenceByConceptID(
  $conceptID: ID!
  $deleted: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelZatcaInvoicesSequenceFilterInput
  $limit: Int
  $nextToken: String
) {
  zatcaInvoicesSequenceByConceptID(
    conceptID: $conceptID
    deleted: $deleted
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      conceptID
      invoiceCounterNumber
      invoiceHash
      isUsed
      pcsid
      deleted
      createdAt
      createdByID
      createdByName
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ZatcaInvoicesSequenceByConceptIDQueryVariables,
  APITypes.ZatcaInvoicesSequenceByConceptIDQuery
>;
export const getInvoiceItemsCode = /* GraphQL */ `query GetInvoiceItemsCode($id: ID!) {
  getInvoiceItemsCode(id: $id) {
    id
    operaCode
    invoiceCode
    name
    vats
    price
    excludeFromZatca
    zatcaExcludeScope
    deleted
    createdAt
    createdByID
    createdByName
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetInvoiceItemsCodeQueryVariables,
  APITypes.GetInvoiceItemsCodeQuery
>;
export const listInvoiceItemsCodes = /* GraphQL */ `query ListInvoiceItemsCodes(
  $filter: ModelInvoiceItemsCodeFilterInput
  $limit: Int
  $nextToken: String
) {
  listInvoiceItemsCodes(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      operaCode
      invoiceCode
      name
      vats
      price
      excludeFromZatca
      zatcaExcludeScope
      deleted
      createdAt
      createdByID
      createdByName
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListInvoiceItemsCodesQueryVariables,
  APITypes.ListInvoiceItemsCodesQuery
>;
export const syncInvoiceItemsCodes = /* GraphQL */ `query SyncInvoiceItemsCodes(
  $filter: ModelInvoiceItemsCodeFilterInput
  $limit: Int
  $nextToken: String
  $lastSync: AWSTimestamp
) {
  syncInvoiceItemsCodes(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    lastSync: $lastSync
  ) {
    items {
      id
      operaCode
      invoiceCode
      name
      vats
      price
      excludeFromZatca
      zatcaExcludeScope
      deleted
      createdAt
      createdByID
      createdByName
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SyncInvoiceItemsCodesQueryVariables,
  APITypes.SyncInvoiceItemsCodesQuery
>;
export const invoiceItemsCodesByZatcaExcludeScope = /* GraphQL */ `query InvoiceItemsCodesByZatcaExcludeScope(
  $zatcaExcludeScope: Int!
  $operaCode: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelInvoiceItemsCodeFilterInput
  $limit: Int
  $nextToken: String
) {
  invoiceItemsCodesByZatcaExcludeScope(
    zatcaExcludeScope: $zatcaExcludeScope
    operaCode: $operaCode
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      operaCode
      invoiceCode
      name
      vats
      price
      excludeFromZatca
      zatcaExcludeScope
      deleted
      createdAt
      createdByID
      createdByName
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.InvoiceItemsCodesByZatcaExcludeScopeQueryVariables,
  APITypes.InvoiceItemsCodesByZatcaExcludeScopeQuery
>;
export const getInvoiceQueue = /* GraphQL */ `query GetInvoiceQueue($id: ID!) {
  getInvoiceQueue(id: $id) {
    id
    billNo
    payloadJson
    status
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetInvoiceQueueQueryVariables,
  APITypes.GetInvoiceQueueQuery
>;
export const listInvoiceQueues = /* GraphQL */ `query ListInvoiceQueues(
  $filter: ModelInvoiceQueueFilterInput
  $limit: Int
  $nextToken: String
) {
  listInvoiceQueues(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      billNo
      payloadJson
      status
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListInvoiceQueuesQueryVariables,
  APITypes.ListInvoiceQueuesQuery
>;
export const syncInvoiceQueues = /* GraphQL */ `query SyncInvoiceQueues(
  $filter: ModelInvoiceQueueFilterInput
  $limit: Int
  $nextToken: String
  $lastSync: AWSTimestamp
) {
  syncInvoiceQueues(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    lastSync: $lastSync
  ) {
    items {
      id
      billNo
      payloadJson
      status
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SyncInvoiceQueuesQueryVariables,
  APITypes.SyncInvoiceQueuesQuery
>;
